import React from 'react';

export const Pill = () => {
  return <div>Pill</div>;
};
